var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agenda",attrs:{"data-scroll-section":""}},[_c('Author',{attrs:{"scroll":_vm.scroll}}),_c('Broadcast',{attrs:{"broadcaseData":_vm.broadcaseData}}),_c('Theme',{attrs:{"agendaDatas":_vm.agendaDatas}}),_c('Speakers',{attrs:{"speakerData":_vm.speakerData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }